import { useState, useEffect } from 'react';
import placeholder from "..//assets/placeholder.png";

const STORAGE_URL = process.env.REACT_APP_STORAGE_PATH;

const ImageWithDefault = ({ src, className }) => {

    const imageName = src;
    src = STORAGE_URL + `/${src}`;

    const [imageSrc, setImageSrc] = useState(src);

    useEffect(() => {
        if (imageName === "") {
            setImageSrc(placeholder);
        } else {
            setImageSrc(src);
        }
    }, [src]);

    const handleError = () => {
        setImageSrc(placeholder);
    };

    return (
        <img
            className={className}
            style={{ width: "98%", maxWidth: "98%" }}
            src={imageSrc}
            onError={handleError}>
        </img>
    )
}

export default ImageWithDefault